// extracted by mini-css-extract-plugin
export default {"app":"apps_app__3G7eN","bg":"apps_bg__Af0DC"};